import { render, staticRenderFns } from "./BaseModalTabs.vue?vue&type=template&id=3bf0ea16&scoped=true"
import script from "./BaseModalTabs.vue?vue&type=script&lang=js"
export * from "./BaseModalTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseModalTabs.vue?vue&type=style&index=0&id=3bf0ea16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0ea16",
  null
  
)

export default component.exports